<template>
	<div>
		<TeamStatusControl @subcommand="subcommand" :subject="slide.settings.subject" type="answers"></TeamStatusControl>
		<div class="notice" v-if="!scenario">Er is geen scenario geselecteerd.</div>
	</div>
</template>

<script>
import BaseSlide from './BaseSlide';
import TeamStatusControl from '../controls/TeamStatusControl';

export default {
	name: 'NieuwsmakerSlide',
	mixins: [BaseSlide],
	components: {
		TeamStatusControl,
	},
	computed: {
		scenario(){
			return this.$actions.getVariable('scenario');
		},
	},
};
</script>

<style></style>
